module.exports = __webpack_public_path__ + "static/media/lazienka-2-min.fe737a06.png";